import { html, slotted, ref } from "@microsoft/fast-element";
const chevronRight16Filled = html.partial(`<svg class="default-marker-collapsed" fill="currentColor" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M5.74 3.2a.75.75 0 00-.04 1.06L9.23 8 5.7 11.74a.75.75 0 101.1 1.02l4-4.25a.75.75 0 000-1.02l-4-4.25a.75.75 0 00-1.06-.04z" fill="currentColor"></path></svg>`);
const chevronDown20Filled = html.partial(`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="default-marker-expanded"
  aria-hidden="true"
>
  <path
    d="M15.794 7.73271C16.0797 8.03263 16.0681 8.50737 15.7682 8.79306L10.5178 13.7944C10.2281 14.0703 9.77285 14.0703 9.48318 13.7944L4.23271 8.79306C3.93279 8.50737 3.92125 8.03263 4.20694 7.73271C4.49264 7.43279 4.96737 7.42125 5.26729 7.70694L10.0005 12.2155L14.7336 7.70694C15.0336 7.42125 15.5083 7.43279 15.794 7.73271Z"
    fill="currentColor"
  />
</svg>`);
export function accordionMenuPanelTemplate() {
    return html `
    <template @keydown="${(x, c) => x.handleKeyDown(c.event)}">
      <div
        ${ref("headingElement")}
        class="heading"
        part="heading"
        role="button"
        tabindex="0"
        aria-expanded="${(x) => x.expanded}"
        aria-controls="${(x) => x.id}-panel"
        aria-disabled="${(x) => x.disabled}"
        id="${(x) => x.id}"
        @click="${(x, c) => x.handleClick(c.event)}"
        @keydown="${(x, c) => x.handleKeyDown(c.event)}"
      >
        <slot name="start"></slot>
        <div class="heading-content" part="heading-content">
          <slot name="heading"></slot>
        </div>
        <div class="markers" part="markers">
          <slot name="marker-expanded">${chevronDown20Filled}</slot>
          <slot name="marker-collapsed">${chevronRight16Filled}</slot>
        </div>
      </div>
      <div
        class="content"
        part="content"
        id="${(x) => x.id}-panel"
        ?hidden="${(x) => !x.expanded}"
      >
        <slot ${slotted("menuList")}></slot>
      </div>
    </template>
  `;
}
/**
 * The template for the accordion menu panel component.
 * @public
 */
export const template = accordionMenuPanelTemplate();
//# sourceMappingURL=accordion-menu-panel.template.js.map